import { Typography } from '@material-ui/core';
import { Inline, Stack } from '@superdispatch/ui';
import { Button } from '@superdispatch/ui-lab';
import { useLoadboardContext } from '../../data/LoadboardContext';

export function PrivatePostingsFindMore() {
  const { router } = useLoadboardContext();

  return (
    <Stack space="small" align="center">
      <Stack space="none">
        <Typography variant="h4" align="center">
          No more private loads
        </Typography>

        <Typography align="center" color="textSecondary">
          Explore a variety of options <br /> on Super Loadboard and stay ahead.
        </Typography>
      </Stack>

      <Inline space="small">
        <Button
          fullWidth={true}
          variant="primary"
          onClick={() => {
            router.openPostingsScreen('available');
          }}
        >
          Search All Available Loads
        </Button>
      </Inline>
    </Stack>
  );
}
